import React from 'react'

// Note: this component is only used for providing example markup to the styleguide.
// Do not import it directly into the application.

function Colors() {
  return (
    <div>
      <h4>Brand Colors</h4>
      <div className="color-block">
        <div className="color primary-base" />
        <div className="text-block">
          <p>$primary-base</p>
        </div>
      </div>
      <div className="color-block">
        <div className="color primary-dark" />
        <div className="text-block">
          <p>$primary-dark</p>
        </div>
      </div>
      <div className="color-block">
        <div className="color secondary-base" />
        <div className="text-block">
          <p>$secondary-base</p>
        </div>
      </div>
      <div className="color-block">
        <div className="color secondary-dark" />
        <div className="text-block">
          <p>$secondary-dark</p>
        </div>
      </div>

      <br />
      <br />

      <h4>Utility Colors</h4>
      <div className="color-block">
        <div className="color red-light" />
        <div className="text-block">
          <p>$red-light</p>
        </div>
      </div>
      <div className="color-block">
        <div className="color red-base" />
        <div className="text-block">
          <p>$red-base</p>
        </div>
      </div>
      <div className="color-block">
        <div className="color red-dark" />
        <div className="text-block">
          <p>$red-dark</p>
        </div>
      </div>
      <div className="color-block">
        <div className="color green-light" />
        <div className="text-block">
          <p>$green-light</p>
        </div>
      </div>
      <div className="color-block">
        <div className="color green-base" />
        <div className="text-block">
          <p>$green-base</p>
        </div>
      </div>
      <div className="color-block">
        <div className="color green-dark" />
        <div className="text-block">
          <p>$green-dark</p>
        </div>
      </div>
      <div className="color-block">
        <div className="color white-base" />
        <div className="text-block">
          <p>$white-base</p>
        </div>
      </div>
      <div className="color-block">
        <div className="color grey-light" />
        <div className="text-block">
          <p>$grey-light</p>
        </div>
      </div>
      <div className="color-block">
        <div className="color grey-base" />
        <div className="text-block">
          <p>$grey-base</p>
        </div>
      </div>
      <div className="color-block">
        <div className="color grey-dark" />
        <div className="text-block">
          <p>$grey-dark</p>
        </div>
      </div>
      <div className="color-block">
        <div className="color black-base" />
        <div className="text-block">
          <p>$black-base</p>
        </div>
      </div>
      <div className="color-block">
        <div className="color black-dark" />
        <div className="text-block">
          <p>$black-dark</p>
        </div>
      </div>
    </div>
  )
}

export default Colors
